import React from 'react';
import { Card } from 'antd';
const { Meta } = Card;
const SkuListCard = ({ img, skuName, data }) => {
    return (
        <Card
            hoverable
            style={{
                width: 250,
                height: 250,
            }}
            key={skuName}
            cover={
                <img
                    style={{ height: '100%', maxWidth: '100%', objectFit: 'contain' }}
                    alt={img?.imagePath?.url}
                    src={img?.thumbPath?.url ?? img?.imagePath?.url}
                />
            }
        >
            <Meta title={skuName} style={{ textAlign: 'center' }} />
        </Card>
    );
};
export default SkuListCard;
